import type {
  SchoolTeacher,
  SchoolTeacherCreateRequest,
  SchoolTeacherUpdateRequest,
} from '../types';

const teacherUpdateFields: Array<keyof SchoolTeacherUpdateRequest> = [
  'name',
  'email',
  'phone',
  'code',
  'unit',
  'subjects',
  'classification',
  'monthlyQuota',
  'position',
  'location',
  'instructorType',
  'skills',
  'certifications',
  'hourlyRate',
  'rating',
  'totalClasses',
  'classId',
];

const toComparableValue = (value: unknown): unknown => {
  if (Array.isArray(value)) {
    return JSON.stringify(value);
  }

  return value ?? '';
};

export const buildTeacherUpdatePayload = (
  teacher: SchoolTeacher,
  formData: SchoolTeacherCreateRequest
): SchoolTeacherUpdateRequest => {
  const originalValues = teacher as unknown as Record<string, unknown>;
  const submittedValues = formData as unknown as Record<string, unknown>;
  const updateData: Record<string, unknown> = {};

  teacherUpdateFields.forEach((field) => {
    const originalValue = toComparableValue(originalValues[field]);
    const submittedValue = toComparableValue(submittedValues[field]);

    if (originalValue !== submittedValue) {
      updateData[field] = submittedValues[field];
    }
  });

  return updateData as SchoolTeacherUpdateRequest;
};
